<template>
    <div
        :class="{ '-error': errors.has(name) }"
        @click="clickHandler"
        class="login-text-input"
    >
        <RightClickMenu
            :menuContent="menuContent"
            class="login-input-row"
            @action="actionEmitted"
        >
            <img
                class="menu-icon"
                :src="require(`@/${valueSpecialIcon}`)"
                alt=""
            />
            <div
                :class="{
                    '-filled': value || value === 0,
                    '-error': errors.has(name)
                }"
                class="login-input-label"
            >
                {{ label }}
            </div>
            <span
                :key="valueDisplay"
                :placeholder="placeholder"
                :value="value"
                @input="onInput"
                ref="input"
                >{{ valueDisplay }}</span
            >
            <i :class="{ '-error': errors.has(name) }" class="material-icons">{{
                icon
            }}</i>
        </RightClickMenu>
    </div>
</template>
<script>
export default {
    props: {
        name: String,
        value: [String, Number],
        placeholder: String,
        errors: Object,
        label: String,
        options: Array,
        icon: String
    },
    computed: {
        menuContent() {
            return this.options.map(option => {
                const object = {
                    event: {
                        name: 'selected',
                        payload: option.key
                    },
                    display: option.display
                }
                if (option.specialIcon) {
                    object.specialIcon = option.specialIcon
                }
                return object
            })
        },
        valueSpecialIcon() {
            return this.options.find(o => o.key == this.value).specialIcon
        },
        valueDisplay() {
            return this.$t(this.options.find(o => o.key == this.value).display)
        }
    },
    methods: {
        actionEmitted(action) {
            this.$emit('input', action.payload)
        },
        clickHandler() {
            this.errors.clear(this.name)
        },
        onInput($event) {
            let value = $event.target.value
            if (value === null) {
                this.$emit('input', value)
                return
            }
            if (this.type === 'number') {
                value = parseInt(value)
            }

            if (this.type === 'price') {
                value = value.replace(',', '.').replace(' ', '')
                let numberRaw = Number(value)
                if (isNaN(numberRaw) === true) {
                    value = 0
                } else {
                    value = Math.round(numberRaw * 100)
                    value = value / 100
                }
            }
            this.$emit('input', value)
        }
    }
}
</script>
<style lang="scss" scoped>
.login-text-input {
    margin-top: 3rem;
    padding: 0.1rem;
    border-bottom: 0.1rem solid $light;
    transition: $ease;
    box-sizing: border-box;

    &.-error {
        border-color: $accent-red;
    }
}
.login-input-label {
    color: $light;
    letter-spacing: 1.25px;
    font-family: $input-family;
    transition: $ease;
    position: absolute;
    pointer-events: none;
    font-size: 1rem;
    &.-filled {
        font-size: 0.9rem;
        transform: translateY(-2rem);
    }

    &.-error {
        color: $accent-red;
    }
}
.login-input-row {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    position: relative;
}
span {
    flex: 1;
    border: none;
    outline: none;
    padding: 0.6rem 0;
    box-sizing: border-box;
    font-size: 1rem;
    letter-spacing: 1px;
    background: transparent;
    border-radius: $input-radius;
    padding-right: 2rem;
    font-family: $input-family;
    color: $input;
    transition: $ease;
    user-select: none;
    cursor: pointer;
}
i {
    color: $light !important;
    transition: $ease;
    position: absolute;
    right: 0;

    &.-focused {
        color: $accent-blue;
    }

    &.-error {
        color: $accent-red;
    }
}
</style>
